import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import projectMappingComponent from './project-mapping.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let projectMappingModule = angular.module('projectMapping', [
  uiRouter,
  modal,
  datepickerPopup,
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('quickbooks-project-mapping', {
    parent: 'app',
    url: '/admin/integrations/quickbooks/project-mapping',
    data: {
      pageHeader: true,
      pageTitle: 'Quickbooks Project Mapping Capability',
      pageDesc: '',
      breadcrumbLink: 'quickbooks',
      breadcrumbText: 'Quickbooks Capabilities'
    },
    template: '<project-mapping></project-mapping>'
  })

})

.component('projectMapping', projectMappingComponent);

export default projectMappingModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/project-mapping/project-mapping.js